import { useState } from "react";
import { Sun, Moon, Download, Zap, Loader2, Share2, FileDown, Menu } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { downloadSourceUrl } from "@/lib/api";
import { toast } from "sonner";

export const Topbar = ({ onMenu, onShare, onExport, canShare }) => {
  const { theme, toggle } = useTheme();
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    toast.info("正在打包项目源码…", { duration: 2000 });
    try {
      const res = await fetch(downloadSourceUrl);
      if (!res.ok) throw new Error("下载失败");
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "frontend-motion-academy.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("源码已开始下载");
    } catch (e) {
      toast.error("源码下载失败，请重试");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <header className="h-14 shrink-0 flex items-center justify-between px-3 sm:px-4 border-b border-border bg-[hsl(var(--surface))]">
      <div className="flex items-center gap-2 sm:gap-3 min-w-0">
        <button
          data-testid="mobile-menu-btn"
          onClick={onMenu}
          aria-label="打开课程目录"
          className="md:hidden flex items-center justify-center h-8 w-8 rounded-md border border-border hover:bg-muted transition-colors"
        >
          <Menu className="h-4 w-4" />
        </button>
        {/* <button
          data-testid="download-source-btn"
          onClick={handleDownload}
          disabled={downloading}
          className="group flex items-center gap-2 px-3 py-1.5 rounded-md bg-primary text-primary-foreground text-xs font-mono font-medium hover:opacity-90 transition-opacity disabled:opacity-60"
        >
          {downloading ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <Download className="h-3.5 w-3.5" />
          )}
          <span className="hidden sm:inline">下载源码</span>
        </button> */}
        <div className="hidden sm:flex items-center gap-2 pl-1">
          {/* <Zap className="h-4 w-4 text-blue-500" /> */}
          <img src="./logo.png" alt="Logo" className="h-4 w-4" />
          <span className="font-heading font-bold text-sm tracking-tight">动效实验室</span>
          <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground hidden lg:inline">
            Frontend Motion Academy
          </span>
        </div>
      </div>

      <div className="flex items-center gap-1.5 sm:gap-2">
        <button
          data-testid="share-link-btn"
          onClick={onShare}
          disabled={!canShare}
          title="分享当前代码（链接复制到剪贴板）"
          className="flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-md border border-border text-xs font-mono hover:bg-muted transition-colors disabled:opacity-50"
        >
          <Share2 className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">分享</span>
        </button>
        <button
          data-testid="export-html-btn"
          onClick={onExport}
          disabled={!canShare}
          title="导出当前课程为独立 HTML 文件"
          className="flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 rounded-md border border-border text-xs font-mono hover:bg-muted transition-colors disabled:opacity-50"
        >
          <FileDown className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">导出 HTML</span>
        </button>
        <button
          data-testid="theme-toggle-btn"
          onClick={toggle}
          aria-label="切换主题"
          className="flex items-center justify-center h-8 w-8 rounded-md border border-border hover:bg-muted transition-colors"
        >
          {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </button>
      </div>
    </header>
  );
};
